import { Controller } from "@hotwired/stimulus"

// Simple inline confirmation popup
// Shows confirm/cancel buttons instead of browser dialog
export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")

    if (!this.menuTarget.classList.contains("hidden")) {
      this.boundClose = this.closeOnClickOutside.bind(this)
      document.addEventListener("click", this.boundClose)
    }
  }

  cancel(event) {
    event.stopPropagation()
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.boundClose)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      document.removeEventListener("click", this.boundClose)
    }
  }

  disconnect() {
    if (this.boundClose) {
      document.removeEventListener("click", this.boundClose)
    }
  }
}
